var theme = {
    bp : {
        xxs: 320, // Mobile
        xs: 600, // Mobile Landscape
        s: 768, // Tablet
        m: 980,
        l: 1024, // Tablet Landscape
        xl: 1200,
        xxl: 1920
    }
};

(function($) {

    
    //console.log('here');

})(jQuery);